module.exports = __webpack_public_path__ + "img/section3.5d21f467.png";